import { Component, ojs, app, payload, each } from "modular-openscriptjs";
import {
	monetary,
	pageInfo,
	either,
	formatDate
} from "../../helpers";
import { PAGES } from "../../declarations";

const h = app("h");
const broker = app("broker");
const $e = app("$e");
const route = app("router");

export default class PaymentRequest extends Component {
	render(requests, ...args) {
		pageInfo(PAGES.PAYMENT_REQUESTS);

		return h.div(
			{ class: "py-md-5" },
			either(requests.value.length < 1, () =>
				h.div(
					{ class: "card" },
					h.div(
						{ class: "card-body text-center" },
						h.span(
							{ class: "text" },
							"You haven't received any top-up request yet. All your top-up requests will appear here."
						)
					)
				)
			),
			each(requests.value, (request) =>
				h.Card(
					{
						header: `Requested on ${formatDate(
							request.created_at
						)}`,
						title: `Requested: ${monetary(request.amount)} `,
						body: [
							h.p(
								h.span({ class: "fw-bold" }, "status: "),
								this.formatStatus(request)
							),
							...either(
								request.payment,
								() => [
									h.p(
										h.span(
											{ class: "fw-bold" },
											"Payment Method: "
										),
										request.payment.method
									),
									h.p(
										h.span(
											{ class: "fw-bold" },
											"Transaction ID: "
										),
										request.payment.transaction_id
									),
								],
								[]
							),
							h.p(
								h.span({ class: "fw-bold" }, "purpose: "),
								request.purpose
							),
							h.p(
								h.span({ class: "fw-bold" }, "Order Number: "),
								h.span("(", request.order?.order_code, ") - "),
								h.span(request.order?.status)
							),
							h.p({ class: "text-muted" }, request.description),
							this.getButtons(request),
						],
					},
					{ class: "mb-4" }
				)
			),
			...args
		);
	}

	formatStatus(request) {
		switch (request.status) {
			case "paid":
				return h.span(
					{ class: "badge rounded-pill text-bg-success" },
					"paid"
				);
			case "unpaid":
				return h.span(
					{ class: "badge rounded-pill text-bg-secondary" },
					"unpaid"
				);
			case "refunded":
				return h.span(
					{ class: "badge rounded-pill text-bg-danger" },
					"refunded"
				);
		}
	}

	getButtons(request) {
		return !request.paid
			? h.div(
					{ class: "mt-1" },
					h.button(
						{
							class: "btn btn-outline-primary",
							onclick: this.method("pay", request),
						},
						"Pay now"
					)
			  )
			: "";
	}

	pay(request) {
		broker.send(
			$e.paymentRequest.needs.payment,
			payload({ request, requestId: request?.id, amount: request?.amount, next: route.current() })
		);
	}
}

ojs(PaymentRequest);
